module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av125-7d8604d0ec2738299e087d7dc8cdfc89.jpg";